import { CoeDepartmentUserEntityModel } from "src/store/models/entity/coeDepartmentUser/entity";
import { CoeDepartmentUserHelperModel } from "src/store/models/entity/coeDepartmentUser/helper";

export const encooCoeDepartmentUserModels = {
  entity: CoeDepartmentUserEntityModel,
  helper: CoeDepartmentUserHelperModel,
};
